import React, { useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Services from "./components/Services";
import Packages from "./components/Packages";
import AboutUs from "./components/AboutUs";
import Properties from "./components/Properties";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function App() {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <div className={`app ${fadeIn ? "fade-in" : ""}`}>
      <Header />
      <AboutUs />
      <Services />
      <Packages />
      <Properties />
      <FAQ />
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;